module.exports = __webpack_public_path__ + "img/lb1.eea914b0.png";